import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { ApiService } from '../../services/api.service';
import { HttpErrorResponse } from '@angular/common/http';
import { switchMap, catchError, throwError, map } from 'rxjs';
import {
  DOWNLOAD_PRECOMPILED_DOCUMENT_MASSIVE_UPLOAD,
  UPLOAD_FILE_MASSIVE,
  UPLOAD_FILE_MASSIVE_ASSOCIATION,
  UPLOAD_FILE_MASSIVE_DATA,
  UPLOAD_FILE_MASSIVE_DATA_ASSOCIATION,
  UPLOAD_FILE_MASSIVE_DATA_SUCCESS,
  UPLOAD_FILE_MASSIVE_SUCCESS,
  UPLOAD_FILE_MASSIVE_UTILITY,
  UPLOAD_FILE_MASSIVE_UTILITY_DATA,
} from './massive-upload.actions';
import { IUploadFileResult } from './massive-upload';
import { GenericResponse } from '../../interfaces/generic-response';
import { DOWNLOAD_FILE } from '../config/config.actions';

@Injectable()
export class MassiveUploadEffects {
  uploadFileMassive$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(UPLOAD_FILE_MASSIVE),
      switchMap(({ payload }: { payload: FormData }) =>
        this.api.uploadMassive(payload)
      ),
      map((uploadFileResult: IUploadFileResult) =>
        UPLOAD_FILE_MASSIVE_SUCCESS({ uploadFileResult })
      ),
      catchError((error: HttpErrorResponse) => {
        return throwError({ error });
      })
    );
  });

  uploadFileMassiveAssociation$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(UPLOAD_FILE_MASSIVE_ASSOCIATION),
      switchMap(
        ({ payload, category }: { payload: FormData; category: string }) =>
          this.api.uploadMassiveAssociation(payload, category)
      ),
      map((uploadFileResult: IUploadFileResult) =>
        UPLOAD_FILE_MASSIVE_SUCCESS({ uploadFileResult })
      ),
      catchError((error: HttpErrorResponse) => {
        return throwError({ error });
      })
    );
  });

  uploadFileMassiveData$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(UPLOAD_FILE_MASSIVE_DATA),
      switchMap(({ payload }: { payload: any }) =>
        this.api.uploadMassiveData(payload)
      ),
      map((uploadFileDataResult: GenericResponse) =>
        UPLOAD_FILE_MASSIVE_DATA_SUCCESS({ uploadFileDataResult })
      ),
      catchError((error: HttpErrorResponse) => {
        return throwError({ error });
      })
    );
  });

  uploadFileMassiveUtilityData$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(UPLOAD_FILE_MASSIVE_UTILITY_DATA),
      switchMap(
        ({ payload, utilityType }: { payload: any; utilityType: string }) =>
          this.api.uploadMassiveDataUtility(payload, utilityType)
      ),
      map((uploadFileDataResult: GenericResponse) =>
        UPLOAD_FILE_MASSIVE_DATA_SUCCESS({ uploadFileDataResult })
      ),
      catchError((error: HttpErrorResponse) => {
        return throwError({ error });
      })
    );
  });

  uploadFileMassiveDataAssociation$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(UPLOAD_FILE_MASSIVE_DATA_ASSOCIATION),
      switchMap(({ payload }: { payload: any }) =>
        this.api.uploadMassiveDataAssociation(payload)
      ),
      map((uploadFileDataResult: GenericResponse) =>
        UPLOAD_FILE_MASSIVE_DATA_SUCCESS({ uploadFileDataResult })
      ),
      catchError((error: HttpErrorResponse) => {
        return throwError({ error });
      })
    );
  });

  uploadFileMassiveUtility$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(UPLOAD_FILE_MASSIVE_UTILITY),
      switchMap(
        ({
          payload,
          utilityType,
        }: {
          payload: FormData;
          utilityType: string;
        }) => this.api.uploadFileMassiveUtility(payload, utilityType)
      ),
      map((uploadFileResult: IUploadFileResult) =>
        UPLOAD_FILE_MASSIVE_SUCCESS({ uploadFileResult })
      ),
      catchError((error: HttpErrorResponse) => {
        return throwError({ error });
      })
    );
  });

  downloadMassiveUploadPrecompiled$ = createEffect(() => {
    let codePrevFile = '';
    let isRecoveryBool = false;
    return this.actions$.pipe(
      ofType(DOWNLOAD_PRECOMPILED_DOCUMENT_MASSIVE_UPLOAD),
      switchMap(({ payload, code, isRecovery }: { payload: FormData; code: string; isRecovery: boolean }) => {
        codePrevFile = code;
        isRecoveryBool = isRecovery;
        return this.api.downloadMassiveUploadPrecompiled(payload);
      }),
      map((response: Blob) =>
        DOWNLOAD_FILE({
          file: response,
          fileName: isRecoveryBool ? `${codePrevFile}_Recovery_Ordini.xlsx` : `${codePrevFile}_Caricamento_Ordini.xlsx`,
        })
      ),
      catchError((error: HttpErrorResponse) => {
        return throwError({ error });
      })
    );
  });

  constructor(private actions$: Actions, private api: ApiService) {}
}
